import {initializeDependency} from "./initialize_dependency";
import {createChatBot, createChatBotEvent} from "./create-chatbot";
import {configCall} from "./config_call";

// Constants for Urls
export const EXTENDED_PAGE_PATH = '/ans/delphi/chatbot/v1';
export const URL_PARAM_KEY = 'chatbotConfig';

// Constants for styles.
// These styles are present in AnsFooterAssetsWebsite package
const delphiChatbotWithBadge = 'delphi-chatbot-with-badge';
const delphiChatbotMinimized = 'delphi-chatbot-minimized';
const delphiChatbotExpanded = 'delphi-chatbot-expanded';
const delphiChatbotClosed = 'delphi-chatbot-closed';
const delphiChatbotBadgeTooltip = 'delphi-chatbot-badge-with-tooltip';
const delphiChatbotBadgeOneLine = 'delphi-chatbot-badge-one-line';
const delphiChatbotBadgeTwoLines = 'delphi-chatbot-badge-two-lines';
const delphiChatbotBadgeMultipleLines = 'delphi-chatbot-badge-multiple-lines';
const delphiChatbotBadgeSmallSize = 'delphi-chatbot-badge-small-size';
const delphiChatbotBadgeMediumSize = 'delphi-chatbot-badge-medium-size';
const delphiChatbotBadgeLargeSize = 'delphi-chatbot-badge-large-size';
const delphiChatbotBadgeXlargeSize = 'delphi-chatbot-badge-xlarge-size';
const delphiChatbotBadgeClassSizes = [
    delphiChatbotMinimized,
    delphiChatbotBadgeSmallSize,
    delphiChatbotBadgeMediumSize,
    delphiChatbotBadgeLargeSize,
    delphiChatbotBadgeXlargeSize
];


// Constants for wrapper elements identifier
const delphiChatbotWrapperPadding = '10px';
const delphiChatbotWrapperId = 'DelphiChatbotWrapper';
const delphiChatbotIframeId = 'DelphiChatbotIframe';
const createChatBotEventTimeout = 5000; // Time in milliseconds ( 5 seconds )
const METRIC_TYPE_STRING = 'String';
const chatBotMain = 'ChatbotMain';
const createEventSuccess = 'CreateEventSuccess';
const createEventFailure = 'CreateEventFailure';
const createEventInvalid = 'CreateEventInvalid';
const invokeABCChatbotFailure = 'InvokeABCChatbotFailure';
const success = 'SUCCESS';

// Events emitted by ABC chatbot
const delphiChatbotEvents = {
    MAXIMIZE: 'DelphiChatbotMaximize',
    MINIMIZE: 'DelphiChatbotMinimize',
    CLOSE: 'DelphiChatbotClose',
    CLOSE_TOOLTIP_SHOW: 'CloseTooltipShow',
    CLOSE_TOOLTIP_HIDE: 'CloseTooltipHide',
    BADGE_ONE_LINE: 'DelphiBadgeWithOneLine',
    BADGE_TWO_LINES: 'DelphiBadgeWithTwoLines',
    BADGE_MULTIPLE_LINES: 'DelphiBadgeWithMultipleLines',
    DELPHI_BADGE_NOTIFICATION_LOADED:'DelphiBadgeNotificationLoaded',
    DELPHI_CHATBOT_LOAD_SUCCESS: 'DelphiChatbotLoadSuccess',
    DELPHI_CHATBOT_WORKFLOW_EVENT: 'DelphiChatbotWorkflowEvent'
};

/**
 * Underlying implementation of P.log is dependent on AUI
 * P object and will not work on pages that do that have this Object.
 * This is the entry point for the client call for loading ABC chatbot as widget.
 */
export function chatbotMain(chatParams, loggerCallback, metricsPublisherCallback) {
    try {
        /**
         * verifyIfChatBotAlreadyPresentOnPage ensures that since we are in a multi tab page and
         * we want our AUI js to be registered only once per page load ot prevents multiple registering
         * of AUI targets.
         * We are adding urlPath to chatParams for validation at backend through CMS if client ID is empty.
         */
        chatParams.data.urlPath = window.parent.location.pathname;
        configCall(chatParams.pageType, chatParams.subPageType);
        createChatBot(chatParams);
    } catch (err) {
        console.log("error occurred in chatbot initialization with message : [%s]",err);
        metricsPublisherCallback.publishMetricLog(
            chatBotMain,
            invokeABCChatbotFailure,
            METRIC_TYPE_STRING
        );
    }

    parent.document.addEventListener(delphiChatbotEvents.DELPHI_CHATBOT_WORKFLOW_EVENT,  async (event) => {

        var response = {
            createEventStatus: 'FAILURE',
            violationMessage: 'Unkown error occured'
        };

        const eventDetail = event.detail;
        const clientId = eventDetail.clientId;
        const eventId = eventDetail.eventId;
        const eventCallbackFunction = eventDetail.eventCallbackFunction;

        if (eventId === null || typeof eventId !== 'string' || eventId === "") {
            response.violationMessage = 'Invalid or null eventId';
        }
        else if (clientId === null || typeof clientId !== 'string') {
            response.violationMessage = 'Invalid or null clientId';
        }
        else if (eventCallbackFunction === null || typeof eventCallbackFunction !== 'function') {
            response.violationMessage = 'Invalid or null eventCallbackFunction';
        }
        else {
            // Setting timeout for createChatBotEvent. We wait for this function to respond for only 5 seconds.
            const setAsyncTimeout = (callbackFunction, timeout) => new Promise((resolve, reject) => {
                callbackFunction(resolve);
                setTimeout(() => reject('Request is taking too long to response'), timeout);
            });

            try {
                await setAsyncTimeout(async (resolve) => {
                    response = await createChatBotEvent(eventId, clientId);
                    resolve();
                }, createChatBotEventTimeout); // 5 seconds max for createChatBotEvent.
            } catch (err) {
                response.violationMessage = 'Request timed out ' + err;
            }
        }
        if (response.createEventStatus === success) {
            const delphiChatbotWrapper = parent.document.getElementById(delphiChatbotWrapperId);
            delphiChatbotWrapper.classList.remove(delphiChatbotClosed);
            parent.document.dispatchEvent(new CustomEvent(delphiChatbotEvents.DELPHI_CHATBOT_LOAD_SUCCESS));
        }
        eventCallbackFunction(response);

        //Publishing Metrics and logs for triggered events.
        if (response.createEventStatus === success) {
            loggerCallback.info('Create event status : SUCCESS for eventId : ' + eventId);
            metricsPublisherCallback.publishMetricLog(
                chatBotMain,
                createEventSuccess,
                METRIC_TYPE_STRING
            );
        }
        else if (response.createEventStatus === 'INVALID') {
            loggerCallback.info(
                'create event status : INVALID for eventId : '
                + eventId + ' with Violation message : '
                + response.violationMessage);
            metricsPublisherCallback.publishMetricLog(
                chatBotMain,
                createEventInvalid,
                METRIC_TYPE_STRING
            );
        }
        else {
            loggerCallback.info(
                'create event status : FAILURE for eventId : '
                + eventId + ' with Violation message : '
                + response.violationMessage);
            metricsPublisherCallback.publishMetricLog(
                chatBotMain,
                createEventFailure,
                METRIC_TYPE_STRING
            );
        }
    });
}

/**
 * This method created an IFrame with source as AnsFooter's loadChatbot method.
 * This method also contains listeners for the events published by ABC chatbot like MAXIMIZE, MINIMIZE, etc.
 * @param urlParams encoded chat params which is passed down as query parameters.
 * @param loggerCallback Callback function to push logs to CloudWatch.
 * @param metricsPublisherCallback Callback function to publish metrics.
 */
export function loadChatbotIframe(urlParams, loggerCallback, metricsPublisherCallback) {
    try {
        loggerCallback.info('Appending event event listener to document');
        document.addEventListener(delphiChatbotEvents.MAXIMIZE, () => {
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            // Remove Minimize and Badge classes and add expanded for increasing Iframe size
            delphiChatbotWrapper.classList.remove(delphiChatbotWithBadge);
            delphiChatbotWrapper.classList.remove(delphiChatbotBadgeOneLine);
            delphiChatbotWrapper.classList.remove(delphiChatbotBadgeTwoLines);
            delphiChatbotWrapper.classList.remove(delphiChatbotBadgeMultipleLines);

            delphiChatbotWrapper.classList.remove(delphiChatbotMinimized);

            delphiChatbotWrapper.classList.add(delphiChatbotExpanded);
            updateDelphiChatbotBadgeMessageClass(true);

        });

        document.addEventListener(delphiChatbotEvents.MINIMIZE, () => {
            // Remove Expanded class and add minimize for reducing Iframe size
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            if(delphiChatbotWrapper.classList.contains(delphiChatbotExpanded)) {
                delphiChatbotWrapper.classList.remove(delphiChatbotExpanded);
                delphiChatbotWrapper.classList.add(delphiChatbotMinimized);
            }
        });

        document.addEventListener(delphiChatbotEvents.CLOSE, () => {
            // Add chatbot closed class which removes whole wrapper div.
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            delphiChatbotWrapper.classList.add(delphiChatbotClosed);
        });

        document.addEventListener(delphiChatbotEvents.CLOSE_TOOLTIP_SHOW, () => {
            // Resize Iframe to increase width according to tooltip
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            delphiChatbotWrapper.classList.add(delphiChatbotBadgeTooltip);
            updateDelphiChatbotBadgeMessageClass(true);
        });

        document.addEventListener(delphiChatbotEvents.CLOSE_TOOLTIP_HIDE, () => {
            // Resize Iframe to back to normal size
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            if(delphiChatbotWrapper.classList.contains(delphiChatbotBadgeTooltip)) {
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeTooltip);
            }
            updateDelphiChatbotBadgeMessageClass(false);
        });

        document.addEventListener(delphiChatbotEvents.BADGE_ONE_LINE, () => {
           // Set the height of Wrapper according to maximum badge height
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            // Only add badge line CSS if chatbot is not already in maximized state.
            if(!delphiChatbotWrapper.classList.contains(delphiChatbotExpanded)) {
                delphiChatbotWrapper.classList.add(delphiChatbotBadgeOneLine);
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeTwoLines);
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeMultipleLines);
            }
        });

        document.addEventListener(delphiChatbotEvents.BADGE_TWO_LINES, () => {
            // Set the height of Wrapper according to maximum badge height
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            // Only add badge line CSS if chatbot is not already in maximized state.
            if(!delphiChatbotWrapper.classList.contains(delphiChatbotExpanded)) {
                delphiChatbotWrapper.classList.add(delphiChatbotBadgeTwoLines);
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeOneLine);
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeMultipleLines);
            }
        });

        document.addEventListener(delphiChatbotEvents.BADGE_MULTIPLE_LINES, () => {
            // Set the height of Wrapper according to maximum badge height
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            // Only add badge line CSS if chatbot is not already in maximized state.
            if(!delphiChatbotWrapper.classList.contains(delphiChatbotExpanded)) {
                delphiChatbotWrapper.classList.add(delphiChatbotBadgeMultipleLines);
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeOneLine);
                delphiChatbotWrapper.classList.remove(delphiChatbotBadgeTwoLines);
            }
        });

        document.addEventListener(delphiChatbotEvents.DELPHI_BADGE_NOTIFICATION_LOADED, (evt) => {
            // Set the width of IFrame according to the range of width of notification badge.
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            // Only set the width according to badge if chatbot is not already in maximized state.
            if(!delphiChatbotWrapper.classList.contains(delphiChatbotExpanded)) {
                const chatbotBadgeWidth = parseInt(evt.detail.elementWidth);
                if (chatbotBadgeWidth == 0) {
                    delphiChatbotWrapper.classList.add(delphiChatbotMinimized);
                } else if (chatbotBadgeWidth <= 135) {
                    delphiChatbotWrapper.classList.add(delphiChatbotBadgeSmallSize);
                } else if (chatbotBadgeWidth <= 155) {
                    delphiChatbotWrapper.classList.add(delphiChatbotBadgeMediumSize);
                } else if (chatbotBadgeWidth <= 175) {
                    delphiChatbotWrapper.classList.add(delphiChatbotBadgeLargeSize);
                } else {
                    delphiChatbotWrapper.classList.add(delphiChatbotBadgeXlargeSize);
                }
            }
        });

        document.addEventListener(delphiChatbotEvents.DELPHI_CHATBOT_LOAD_SUCCESS, () => {
            // Make the IFrame wrapper visible if chatbot load was successful.
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            delphiChatbotWrapper.style.visibility='visible';
        });

        const updateDelphiChatbotBadgeMessageClass = (remove) => {
            const delphiChatbotWrapper = document.getElementById(delphiChatbotWrapperId);
            const BACKUP_CSS = 'backup';
            // Remove delphi chatbot badge size classes if remove is true
            // Otherwise add delphi chabot badge size classes to Delphi chatbot wrapper.
            delphiChatbotBadgeClassSizes.every((delphiChatbotWrapperBadgeClass) => {
                if(delphiChatbotWrapper.classList.contains(delphiChatbotWrapperBadgeClass
                    + (remove ? '' : BACKUP_CSS))) {
                    delphiChatbotWrapper.classList.remove(delphiChatbotWrapperBadgeClass
                        + (remove ? '' : BACKUP_CSS));
                    delphiChatbotWrapper.classList.add(delphiChatbotWrapperBadgeClass
                        + (remove ? BACKUP_CSS : ''));
                    return false;
                }
                return true;
            });
        }

        loggerCallback.info('Creating Chatbot Wrapper and IFrame');
        const baseUrl = window.location.origin.concat(EXTENDED_PAGE_PATH);
        const chatbotIframe = document.createElement('iframe');

        chatbotIframe.id = delphiChatbotIframeId;
        chatbotIframe.src = baseUrl.concat(`?${URL_PARAM_KEY}=${urlParams}`);

        const chatbotWrapper = document.createElement('div');
        chatbotWrapper.id = delphiChatbotWrapperId;
        chatbotWrapper.classList.add(delphiChatbotWithBadge);
        if (parent.document.dir === 'rtl') {
            chatbotWrapper.style.left = delphiChatbotWrapperPadding;
        } else {
            chatbotWrapper.style.right = delphiChatbotWrapperPadding;
        }
        chatbotWrapper.appendChild(chatbotIframe);

        document.body.appendChild(chatbotWrapper);
    } catch (err) {
        loggerCallback.error("Error occurred while creating delphi chatbot iframe wrapper", err);
        metricsPublisherCallback(
            'LoadChatbotIFrame',
            'IFrameCreationFailure',
            'String'
        );
    }
}

